'use client';
import useMediaQuery from '@mui/material/useMediaQuery';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import getComponents from '@functions/component-functions';
import { breakdownChildResponse } from '@functions/amplience-functions';
import DeliveryKeyContext from '../../context/delivery-key-context';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const Story = (props) => {
  const { _meta, bannerImage, title, description, contentRows } = props;

  const xs = useMediaQuery((theme) => theme.breakpoints.only('xs'));
  const sm = useMediaQuery((theme) => theme.breakpoints.only('sm'));

  const imgUrl = buildImageSrc(bannerImage, xs ? 600 : 2000, xs ? 2.5 : sm ? 3 : 4, 1);

  const components =
    contentRows && contentRows.components ? breakdownChildResponse(contentRows.components) : null;

  return (
    <div>
      {bannerImage && (
        <LazyLoadImage
          imgComponent={
            <img
              src={imgUrl}
              alt={bannerImage.name}
              width="100%"
              className="tw-max-h-[300px] tw-object-cover"
            />
          }
        />
      )}
      <Container
        sx={{ px: { xs: 3, md: 5 }, my: { xs: 4, md: 5, lg: 6 }, maxWidth: '1000px', mx: 'auto' }}
      >
        {title && (
          <Typography component="h1" variant="h2" align="center">
            {title}
          </Typography>
        )}
        {description && (
          <Typography variant="body1" align="center" mt={3} sx={{ fontStyle: 'italic' }}>
            {description}
          </Typography>
        )}
      </Container>
      <DeliveryKeyContext.Provider value={_meta?.deliveryKey}>
        {components && components.map((cmpt) => getComponents(cmpt))}
      </DeliveryKeyContext.Provider>
    </div>
  );
};

export default Story;
